export const toCamelCase = (str: string): string => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const convertKeysToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc: any, key: string) => {
      acc[toCamelCase(key)] = convertKeysToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

export const getDataFromFile = async (url: string, setData: any) => {
  try {
    await fetch(url).then(async (response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const data = await response.json();
      const camelCaseData = convertKeysToCamelCase(data);
      setData(camelCaseData);
    });
  } catch (error: any) {
    console.error("Error fetching data:", error.message);
    return null;
  }
};

export const mapLayoutData = (configLayout: any, specLayout: any) => {
  configLayout.rowFirst.rooms.forEach((room: any, index: number) => {
    const newSpaceFunctions = {
      name: specLayout.rowFirst.rooms[index].spaceFunction.name,
      parameters: specLayout.rowFirst.rooms[index].spaceFunction.parameters,
    };
    room.spaceFunction = newSpaceFunctions;
    room.length = specLayout.rowFirst.rooms[index].length;
  });
  configLayout.rowSecond.rooms.forEach((room: any, index: number) => {
    const newSpaceFunctions = {
      name: specLayout.rowSecond.rooms[index].spaceFunction.name,
      parameters: specLayout.rowSecond.rooms[index].spaceFunction.parameters,
    };
    room.spaceFunction = newSpaceFunctions;
    room.length = specLayout.rowSecond.rooms[index].length;
  });

  return configLayout;
};

export const mapElementTypesData = (
  configElementTypes: any,
  specElementTypes: any
) => {
  const elementTypes = [
    "wallInterior",
    "wallExterior",
    "roof",
    "floor",
    "floorGround",
  ];

  elementTypes.forEach((type) => {
    configElementTypes.elementTypes[type].value =
      specElementTypes.elementTypes[type].name;
  });

  configElementTypes.elementTypes.windowType.name = specElementTypes.windowType.name;

  return configElementTypes;
};

export const mapBuildingInfoData = (configBuildingInfo: any, specBuildingInfo: any) => {
  configBuildingInfo.height.value.value = specBuildingInfo.height;
  configBuildingInfo.info.rotation.angle.value = specBuildingInfo.info.rotation.angle.value;

  return {
    height: configBuildingInfo.height,
    orientation: configBuildingInfo.info.rotation,
    isModular: specBuildingInfo.lengthOptions.modular,
  };
}	